import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const KEYS = {
  SetForms: 'set_forms',
  SetSystemForms: 'set_system_forms',
  Clear: 'clear'
}

export const state = {
  forms: [],
  systemForms: []
}
export const mutations = {
  [KEYS.SetForms](state, list) {
    if (list && Array.isArray(list)) {
      state.forms = list
    } else {
      state.forms = []
    }
  },
  [KEYS.SetSystemForms](state, list) {
    if (list && Array.isArray(list)) {
      state.systemForms = list
    } else {
      state.systemForms = []
    }
  },


  [KEYS.Clear](state) {
    state.forms = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    var key = 'forms.with.auto-account-types'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })
      if (cached != null) {
        commit(KEYS.SetForms, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('general.forms'))
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: result.data.items
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(KEYS.SetForms, cacheObj.value)
    }
  },

  async refreshSystemForms({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    var key = 'forms.system-forms'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })
      if (cached != null) {
        commit(KEYS.SetSystemForms, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('general.system-forms'))
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: result.data.items
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(KEYS.SetSystemForms, cacheObj.value)
    }
  },

  set({ commit }, list) {
    commit(KEYS.SetForms, list)
  },

  clear({ commit }) {
    commit(KEYS.Clear)
  }
}
export const getters = {
  all: state => {
    return state.forms
  },
  
  findFormByKey: state => key => {
    return _.head(state.forms.filter(item => item.key === key))
  },
  findSystemFormByKey: state => name => {
    return _.head(state.systemForms.filter(item => item.name === name))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
